module.exports = __webpack_public_path__ + "img/others_qr_code.f555137e.png";